import { z } from 'zod';

export const schoolSchema = z.object({
  id: z.number(),
  nome: z.string(),
  uf: z.string().optional(),
  cidade: z.string().optional(),
  tipoRedacaoPermitido: z.string().optional(),
  parceiroIntegracao: z.boolean().optional(),
  mec: z.string().optional(),
});

export type School = z.infer<typeof schoolSchema>;

export const schoolsResponseSchema = z.array(schoolSchema);

export type SchoolsResponse = z.infer<typeof schoolsResponseSchema>;
